class CareSelector extends HTMLElement {
    camera = 'PROMAX';
    loading = false;
    id = '';
    productTitle = '';
    constructor() {
      super();
      this.init();
      this.cart =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');
      this.careGuide = this.dataset.careGuide;
      this.careList = JSON.parse(this.dataset.careList);
      this.hasCare = this.careList.length > 0;
      this.showCareVersionNames = this.dataset.showCareVersionNames ? this.dataset.showCareVersionNames.split('\n') : [];
    }
    init() {
      Array.from(this.getElementsByClassName('care-camera-options')).forEach(
        (el) => {
          el.addEventListener('click', () => {
            this.chooseCamera(el);
          });
        }
      );
      Array.from(this.getElementsByClassName('care-version-options')).forEach(
        (el) => {
          el.addEventListener('click', () => {
            this.chooseVersion(el);
          });
        }
      );
      this.querySelector('.care-btn').addEventListener('click', () => {
        if (this.careGuide === 'strong' && this.hasCare && this.showCareVersionNames.includes(this.productTitle)) {
          this.showCareChooseDialog();
        } else {
          this.handleAddToCart();
        }
      });
      
      const defaultSelect = Array.from(
        this.querySelectorAll('.care-camera-options')
      ).find((el) => el.dataset.camera == this.camera);
      if (defaultSelect) {
        this.chooseCamera(defaultSelect);
      } else {
        this.camera = this.querySelector('.care-camera-options').dataset.camera;
  
        this.chooseCamera(this.querySelector('.care-camera-options'));
      }
    }
  
    showCareChooseDialog() {
      console.log('showCareChooseDialog ----- ');
      const careDialog = document.querySelector(
        'product-detail-dialog-hovercare-choose'
      );
      careDialog.showModal();
    }
  
    chooseCamera(el) {
      const cameraOptions = this.querySelectorAll('.care-camera-options');
      cameraOptions.forEach((option) => option.classList.remove('selected'));
  
      if (el.dataset.camera) {
        this.camera = el.dataset.camera;
        el.classList.add('selected');
        const versionOptions = this.querySelectorAll('.care-version-options');
        versionOptions.forEach((el) => {
          el.style.display = el.dataset.camera == this.camera ? 'block' : 'none';
        });
      }
      const defaultVersion = Array.from(
        this.querySelectorAll('.care-version-options')
      ).find((el) => getComputedStyle(el).display !== 'none');
      this.chooseVersion(defaultVersion);
  
      this.toggleTable();
    }
    chooseVersion(el) {
      this.id = el.dataset.id;
      this.productTitle = el.dataset.versionName || '';
      const veresionOptions = this.querySelectorAll('.care-version-options');
      veresionOptions.forEach((option) => {
        if (option.dataset.id != this.id) {
          option.classList.remove('selected');
        } else {
          option.classList.add('selected');
        }
      });
    }
    async handleAddToCart() {
      if (this.loading) {
        return;
      }
      const data = {
        items: [
          {
            id: this.id,
            quantity: 1,
          },
        ],
        sections: 'cart-drawer,cart-icon-bubble',
      };
  
      this.toggleLoading();
      await fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: this.id,
              errors: response.errors || response.description,
              message: response.message,
            });
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
  
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: this.mainProductId,
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty'))
            this.cart.classList.remove('is-empty');
          this.toggleLoading();
        });
    }
    guideAddToCart(chooseId) {
      this.id = chooseId;
      this.handleAddToCart();
    }
    toggleLoading() {
      this.loading = !this.loading;
      this.querySelector('.buy-loading').classList.toggle('tw-hidden');
    }
    toggleTable() {
      // Attempt to find the container within the same section first, fallback to document
      let hoverCareSpecsContainer = null;
      const section = this.closest('.shopify-section');
      if (section) {
        hoverCareSpecsContainer = section.querySelector('.hover-care-specs-container');
      } 
      
      if (!hoverCareSpecsContainer) return;
  
      const tableMap = {
        'X1': '.Hovercare-130-table',
        'X1 PRO': '.Hovercare-141-table',
        'PROMAX': '.Hovercare-141-pro-table',
        'AQUA': '.Hovercare-151-aqua-table'
      };
  
      // Hide all first
      Object.values(tableMap).forEach(selector => {
        const el = hoverCareSpecsContainer.querySelector(selector);
        if (el) el.style.display = 'none';
      });
  
      // Show active
      const activeSelector = tableMap[this.camera];
      if (activeSelector) {
        const activeEl = hoverCareSpecsContainer.querySelector(activeSelector);
        if (activeEl) activeEl.style.display = 'block';
      }
    }
  }
  
  if (!customElements.get('care-selector')) {
    customElements.define('care-selector', CareSelector);
  }
  